import styled from 'styled-components';
import { MainPage } from 'Container';

export default styled(MainPage).attrs({
  className: 'checkout mt-0 mt-md-5',
  title: 'Dein Balloon Upgrade',
  bodyClassName: 'main-decorated-discreet upgrade-subscription',
  containerClassName: 'px-0'
})``;
